<template>
  <div class="dialog">
    <transition name="fade">
      <div
        @click="handleClick"
        class="dialog-mask"
        v-show="visible"
      ></div>
    </transition>
    <transition name="ease">
      <div
        class="dialog-wrap"
        v-show="showWrap"
        :style="styles"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 520
    },
    height: {
      type: [Number, String],
      default: 300
    },
    maskClosable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showWrap: false
    };
  },
  computed: {
    styles() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`
      };
    }
  },
  watch: {
    visible(val) {
      if (val) {
        setTimeout(() => {
          this.showWrap = true;
        }, 300);
      } else {
        this.showWrap = false;
      }
    }
  },
  methods: {
    handleClick() {
      if (this.maskClosable) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.showWrap = true;
    }
  }
};
</script>

<style lang="less" scoped>
.dialog {
  &-mask,
  &-wrap {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: @zIndex-dialog;
  }
  &-mask {
    background-color: rgba(0,0,0,.75);
  }
  &-wrap{
    margin: auto;
  }
}
</style>
